import React from "react";
import { Trans } from "app/utils";
import { AiImageIcon, BookGradientIcon, StoryTellingIcon } from "components/common/icons";

const StorytellingGuide: React.FC = () => (
  <div className="storytelling-guide">
    <h3 className="guide-title">
      <Trans>Meet your storytelling guide</Trans>
    </h3>
    <div className="guide-paragraph__sub">
      <span>
        <Trans>
          Our AI-assisted approach will help you craft your unique story
        </Trans>
      </span>
    </div>
    <div className="guide-paragraph">
      <StoryTellingIcon />
      <span>
        <Trans>Answer a few quick questions
          related to this prompt
        </Trans>
      </span>
    </div>
    <div className="guide-paragraph">
      <BookGradientIcon />
      <span>
        <Trans>A personal story will be crafted
          for you to edit/approve
        </Trans>
      </span>
    </div>
    <div className="guide-paragraph">
      <AiImageIcon />
      <span>
        <Trans>
          Specific recommendations for
          photos to add and a video script
        </Trans>
      </span>
    </div>
  </div>
);

export default StorytellingGuide;
